import { HttpErrorResponse } from '@angular/common/http';
import { ErrorHandler, Injectable, NgZone, inject } from '@angular/core';
import { ToastService } from './toast.service';

@Injectable()
export class GlobalErrorHandler implements ErrorHandler {
  private toast = inject(ToastService);
  private zone = inject(NgZone);

  handleError(error: any): void {
    const msg = error?.message || 'An unexpected error occurred';
    console.error('Uncaught error:', error);
    // A 403 nobody handled is a screen loading data this role can't see (e.g. Read-only on
    // Absences or Timesheets) — the server already refused it; don't alarm the user.
    if (error instanceof HttpErrorResponse && error.status === 403) return;

    this.zone.run(() => {
      this.toast.error('Something went wrong — please refresh if the issue persists');
    });
  }
}
